import { GOAL_REAL_YIELD } from "web_myplann/Goals/constants";

export const calcPerpetualRentTotal = (monthly: number): number => {
	if (monthly <= 0) return 0;
	return Math.round((monthly * 12) / GOAL_REAL_YIELD);
};
